import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const permission = map.usePermission()
    map.useMetaData()
    const {canUndoReviseMap, undoReviseMap} = map.commands

    if (! (
        canUndoReviseMap() &&
        permission.has('write')
    )) {
        return null
    }

    const onClick = async () => {
        const isConfirmed = await openModal(
            <Confirm>
                确定撤销修订？（撤销修订后，模型将恢复至最近一次发布版）
            </Confirm>
        )

        if (isConfirmed) {
            undoReviseMap()
        }
    }

    return {
        key: 'undo-revise-map',
        label: '撤销修订',
        onClick,
    }
}
